import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — every route change resets the scroll position to the top.
 * React Router does NOT do this by default, which causes pages to open in
 * the middle/bottom when the previous page was scrolled.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Use 'auto' (instant) so users don't see a janky scroll on every nav.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, search]);
  return null;
}
